import React, { useEffect, useState } from 'react'
import { withHeaderMessages } from '../higherOrderComponents/WithHeaderMessages';
import { WithApiAccess } from '../lib/HigherOrderComponents/WithApiAccess';
import { useNavigate } from 'react-router-dom';

function Payment(props) {
	const [users, setUsers] = useState({})
  const navigate = useNavigate();

  useEffect(() => {
		async function getCustomerProfile() {
			await props.api
				.get("/api/user")
				.then((response) => {
					if (response.status === 200) {
						return response.data;
					}
				})
				.then((data) => {
          setUsers(data)
				})
		}
		getCustomerProfile();
	}, [users]);

  const renderCheckout = () => {
      window.CollectCheckout.redirectToCheckout({
        type: "sale",
        lineItems: [
          {
            lineItemType: "customPayment",
            description: "Preneed Payment Amount",
            currency: "USD",
          },
        ],
        successUrl: null,
        cancelUrl: null,
        customerVault: {
          addCustomer: true,
        },
        receipt: {
          showReceipt: true,
          sendToCustomer: true,
        },
        useKount: false,
        paymentMethods: [
          {
            type: "creditCard",
            use3DSecure: false,
          },
          {
            type: "googlePay",
            use3DSecure: false,
          },
        ],
        fields: [
          {
            field: "merchant_defined_field_1",
            required: true,
          },
          {
            field: "merchant_defined_field_2",
            required: true,
          },
          {
            field: "merchant_defined_field_3",
            required: true,
          },
          {
            field: "merchant_defined_field_4",
            required: false,
          },
          {
            field: "merchant_defined_field_5",
            required: false,
          },
          {
            field: "merchant_defined_field_6",
            required: false,
          },
          {
            field: "merchant_defined_field_7",
            required: false,
          },
        ],
      }).then((error) => {
        console.log(error);
      })
  }

  return (
		<div>
			{users.customers &&
			users.customers.length > 0 &&
			users.acceptCreditCard &&
			users.customers.every((c) => c.providers.every((p) => p.acceptCreditCard))
				? renderCheckout()
				: navigate("/")}
		</div>
	);
}

export default withHeaderMessages(WithApiAccess(Payment));